import styled from "styled-components";
import { Icon, Type } from "@ebscois/react-component-library";

export const SubtitleItem = styled.div`
  margin: 0 ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.sm} 0;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    &:first-child > span:first-child {
    ${({ pageType, heading, theme }) =>
      pageType === "genericNames" &&
      heading &&
      `color: ${theme.colors.primary.base}`};
    font-family: ${({ theme }) => theme.font.family.secondary};
    font-size: ${({ theme }) => theme.font.size.xl};
    font-weight: 400;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
    ${({ pageType }) => pageType === "classification" && `flex-direction: row;`}
    ${({ pageType, heading }) =>
      pageType === "genericNames" && heading === "Canada" && `display: inline;`}
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    &:last-of-type {
      margin-right: 0;
      border-right: none;
      padding-right: 0;
    }
  }
`;

export const SubtitleIcon = styled(Icon)`
  vertical-align: middle;
`;

export const SubtitleItemCaption = styled.span`
  font-weight: 600;
`;
export const Pronunciation = styled.p`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: 400;
  display: inline;
`;

export const Title = styled(Type)`
  margin-bottom: ${({ theme }) => theme.space.sm};
`;
